###
Require authentication
###
export default ({ app, store, redirect }) ->
	await app.$customerHydrated
	unless store.getters['customer/isAuthenticated']
	then redirect '/account/login'
